import React, { useEffect } from 'react';
import Modal from 'components/new_ui/Modal/Modal';

import { Button } from 'react-bootstrap5';

import { useNavigate, useParams } from 'react-router-dom';

import useLesson from 'components/Common/Members/Hooks/useLesson';

import LoadingPlaceholder from 'components/new_ui/WaitLayers/LoadingPlaceholder';

import ExternalLink from 'components/Widgets/ExternalLink';

function copyStringToClipboard(str) {
  // Create new element
  const el = document.createElement('textarea');
  // Set value (string to be copied)
  el.value = str;
  // Set non-editable to avoid focus and move outside of view
  el.setAttribute('readonly', '');
  el.style = { position: 'absolute', left: '-9999px' };
  document.body.appendChild(el);
  // Select text inside element
  el.select();
  // Copy text to clipboard
  document.execCommand('copy');
  // Remove temporary element
  document.body.removeChild(el);
}

export default function Index() {
  const navigate = useNavigate();

  const { stepId } = useParams();

  const session = useLesson(stepId);

  const returnBack = () => {
    navigate(-1);
  };

  useEffect(() => {
    if (session) {
      copyStringToClipboard(session.attributes.zoom_link);
    }
  }, [session]);

  return (
    <Modal
      header={
        <h3>{session && session.attributes.title}</h3>
      }
      show
      onHide={returnBack}
    >
      {!session && <LoadingPlaceholder text="Loading..." />}
      {session && (
      <>
        <p>
          Here is a link to start session
          {' '}
          {session.attributes.title}
          ,
          we also copied it to your clipboard.
        </p>

        <ExternalLink
          variant={null}
          href={session.attributes.zoom_link}
        >
          {session.attributes.zoom_link}
        </ExternalLink>
        <p className="mt-3">
          This is your meeting information:
        </p>
        <p>
          Zoom:
          {' '}
          <ExternalLink
            variant={null}
            href={session.attributes.zoom_link}
          >
            {session.attributes.zoom_link}
          </ExternalLink>
        </p>
        <p>
          Meeting ID:
          {' '}
          {session.attributes.zoom_id}
        </p>
        <p>Dial by your location:</p>
        {session.attributes.zoom_options.phone.map((phone) => (
          <div>
            {phone.phone}
            {' '}
            (
            {phone.city}
            )
          </div>
        ))}
        <p className="mt-3">
          Find your local number:
          <br />
          <ExternalLink
            variant={null}
            href="https://zoom.us/u/abVFs1Rsg4"
          >
            https://zoom.us/u/abVFs1Rsg4
          </ExternalLink>
        </p>

        <footer className="d-flex justify-content-end">
          <Button onClick={returnBack}>OK</Button>
        </footer>
      </>
      )}

    </Modal>
  );
}
